import style from "./style.scss";

import { mergeClasses } from "../../../../components/helpers";
import NoWrap from "../../../../components/no-wrap";
import Link from "../../../../components/link";

const CalendarIcon = ({ class: className }) => (
  <svg
    class={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const Promo = ({ href, affiliateData }) => (
  <ul class={style.promoCards}>
    <li class={mergeClasses([style.promoCard, style.bestDeal])}>
      <Link affiliateData={affiliateData} href={href} class={style.wrapper}>
        <div class={style.cardHeader}>
          <div class={style.badgeStack}>
            <span class={mergeClasses([style.badge, style.badgeOrange])}>
              Super Early-Bird
            </span>
            <span class={style.subBadge}>Lowest Price</span>
          </div>
        </div>
        <div class={style.price}>$1,099</div>
        <div class={style.details}>
          <CalendarIcon class={style.icon} />
          <div>
            <NoWrap>Nov 4, 6 PM –</NoWrap> <NoWrap>Nov 18, 5:59 PM PST</NoWrap>
          </div>
        </div>
      </Link>
    </li>

    <li class={style.promoCard}>
      <Link affiliateData={affiliateData} href={href} class={style.wrapper}>
        <div class={style.cardHeader}>
          <div class={style.badgeStack}>
            <span class={mergeClasses([style.badge, style.badgeBlue])}>
              Early Bird
            </span>
          </div>
        </div>
        <div class={style.price}>$1,149</div>
        <div class={style.details}>
          <CalendarIcon class={style.icon} />
          <div>
            <NoWrap>Nov 19, 6 PM –</NoWrap> <NoWrap>Nov 29, 5:59 PM PST</NoWrap>
          </div>
        </div>
      </Link>
    </li>

    <li class={style.promoCard}>
      <Link affiliateData={affiliateData} href={href} class={style.wrapper}>
        <div class={style.cardHeader}>
          <div class={style.badgeStack}>
            <span class={style.badge}>Launch Price</span>
          </div>
        </div>
        <div class={style.price}>$1,199</div>
        <div class={style.details}>
          <CalendarIcon class={style.icon} />
          <div>
            <NoWrap>Nov 30, 6 PM –</NoWrap> <NoWrap>Dec 4, 5:59 PM PST</NoWrap>
          </div>
        </div>
      </Link>
    </li>
  </ul>
);

export default Promo;
